import { makeStyles } from "@material-ui/core";

export const AttachmentsStyle = makeStyles((theme) => ({
    title: {
        fontSize: '1.5em',
        cursor: 'pointer',
        fontWeight: 500,
        padding: '.3em'
    },
    commentIcon: {
        marginRight: '0.2em'
    },
    icon: {
        display: 'flex',
        alignItems: 'center',
        padding: '.5em'
    },
    attachmentsTooltip: {
        opacity: 0.5,
        transition: 'opacity 0.2s ease',
        '&:hover': {
            opacity: 1
        },
    },
    attachmentsTooltipOn: {
        opacity: 1,
    },
    documentTypes: {
        marginBottom: '1em'
    },
    imageContainer: {
        position: 'relative'
    },
    imageTag: {
        position: 'absolute',
        borderRadius: '3px',
        bottom: '2em',
        right: '2em',
        //left: '50%',
        //transform: 'translateX(-50%)',
        background: '#efefef',
        padding: '2px 5px',
        fontSize: '0.7em',
        fontWeight: 'bold'
    }
}))